package fr.frux.feature.site.create

import androidx.compose.runtime.Composable
import androidx.compose.runtime.staticCompositionLocalOf
import androidx.lifecycle.viewmodel.compose.viewModel

/** Contrat de fabrique du [CreateSiteViewModel], honoré par le composition root (#43). */
fun interface CreateSiteViewModelFactory {
    fun create(args: CreateSiteArgs): CreateSiteViewModel
}

/** Fabrique installée par le composition root, sans défaut : l'oubli de câblage doit crier. */
val LocalCreateSiteViewModelFactory =
    staticCompositionLocalOf<CreateSiteViewModelFactory> {
        error(
            "CreateSiteViewModelFactory absente : le composition root doit l'installer " +
                "(cf. FruxCompositionRoot, #43)",
        )
    }

@Composable
fun rememberCreateSiteViewModel(args: CreateSiteArgs): CreateSiteViewModel {
    val factory = LocalCreateSiteViewModelFactory.current
    return viewModel { factory.create(args) }
}
